import classNames from 'classnames'
import dynamic from 'next/dynamic'
import { Dispatch, SetStateAction } from 'react'
import { BETA_INDSTOCKS_HOST, INDSTOCKS_HOST } from '@/root/constants/common'

const MobileNavigationOverlay = dynamic(
  () => import('../header/mobile-navigation-overlay'),
  {
    ssr: true,
  },
)

const MobileNavigationOverlayV3 = dynamic(
  () => import('./MobileNavigationOverlayV3'),
  {
    ssr: true,
  },
)

type TProps = {
  host: string
  isAuthenticated: boolean
  mwebNavigation: boolean
  toggleMwebNavigation: Dispatch<SetStateAction<boolean>>
}

const MobileNavSlider = ({
  host,
  isAuthenticated,
  mwebNavigation,
  toggleMwebNavigation,
}: TProps) => {
  return (
    <section
      className={classNames(
        'fixed right-0 top-0 z-[1000] mt-[61px] h-full w-full overflow-y-scroll bg-brand-grey-background transition-transform duration-200 ease-in-out md:w-96',
        {
          'translate-x-full': !mwebNavigation,
          'translate-x-0': mwebNavigation,
        },
      )}
    >
      {host === INDSTOCKS_HOST || host === BETA_INDSTOCKS_HOST ? (
        <MobileNavigationOverlay
          closeNavigation={() => toggleMwebNavigation(false)}
          host={host}
          isOpen={mwebNavigation}
        />
      ) : (
        <MobileNavigationOverlayV3
          closeOverlay={() => toggleMwebNavigation(false)}
          isOpen={mwebNavigation}
          isAuthenticated={isAuthenticated}
        />
      )}
    </section>
  )
}

export default MobileNavSlider
